export const initialKpiRealTime = () => {
    return ({
        listAllSales: [],
        currentDaySales: [],
        lastDaySales: [],
        timeMetrics: [],
    })
}

function groupByDay(data) {
    const groupedData = {};

    data?.forEach((item) => {
        const day = item.dia

        if (!groupedData[day]) {
            groupedData[day] = {
                day: day,
                records: [],
            };
        }
        groupedData[day].records.push(item);
    });

    return Object.values(groupedData);
}

// function groupByOrderTable(data) {
//     const groupedData = {};

//     data?.forEach((item) => {

//         let table = '0'
//         if (item.tipoPedido === 'MESA') {
//             table = item.identificadorPrincipal
//         } else {
//             table = item.identificadorSecundario || '0'
//         }

//         if (!groupedData[table]) {
//             groupedData[table] = {
//                 table: table,
//                 records: [],
//             };
//         }

//         groupedData[table].records.push(item);
//     });

//     return Object.values(groupedData);
// }

function groupByOrderTable(data) {
    const groupedData = {};

    data?.forEach((item) => {
        // Normaliza campos
        const tipoPedido = item.tipoPedido || item.tipo_pedido;
        const identificadorPrincipal =
            item.identificadorPrincipal ?? item.identificador_principal;
        const identificadorSecundario =
            item.identificadorSecundario ?? item.identificador_secundario;

        let table = null;

        if (tipoPedido === 'MESA') {
            table = identificadorPrincipal;
        } else {
            table = identificadorSecundario;
        }

        // 🔥 **Ignorar mesas/comandas nulas, vazias, 0, undefined**
        if (
            table === null ||
            table === undefined ||
            table === '' ||
            table === 0 ||
            table === '0'
        ) {
            return; // skip
        }

        // Converte para string para padronizar agrupamento
        table = String(table);

        if (!groupedData[table]) {
            groupedData[table] = {
                table,
                records: [],
            };
        }

        groupedData[table].records.push(item);
    });

    return Object.values(groupedData);
}


export const kpiRealTime = (currentState, action) => {
    const { kpiRealTime: currentKpiRealTime } = currentState;
    const {
        listIdentifier,
        kpiToday = [],
        kpiRealTime: openOrders,
        kpiTimeMetrics = [],
        selectedDate
    } = action;

    const currentDate = new Date(selectedDate);

    // Inicializa o objeto `kpiRealTime`
    const kpiRealTime = {
        listAllSalesToday: currentKpiRealTime?.listAllSalesToday || [],
        currentDaySales: currentKpiRealTime?.currentDaySales || [],
        lastDaySales: currentKpiRealTime?.lastDaySales || [],
        countTable: currentKpiRealTime?.countTable || 0,
        listOrdersTable: currentKpiRealTime?.listOrdersTable || [],
        listOfOpenOrders: currentKpiRealTime?.listOfOpenOrders || [],
        timeMetrics: currentKpiRealTime?.timeMetrics || [],
        selectedDate: currentDate,
        currentDate: currentDate.getMonth() + 1,
        currentMonth: currentDate.getMonth() + 1,
        currentDay: currentDate.getDate(),
        date: new Date()
    }

    // Manipula informações da lista de identificadores
    if (listIdentifier) {
        const tableData = listIdentifier.find(e => e.tipo === "MESA");
        kpiRealTime.countTable = tableData ? parseInt(tableData.quantidade) : 1;
    }

    // Manipula informações de pedidos de hoje
    if (Array.isArray(kpiToday) && kpiToday.length > 0) {
        kpiRealTime.listAllSalesToday = kpiToday;

        const groupedData = groupByDay(kpiToday);
        kpiRealTime.currentDaySales = groupedData.find(e => e.day === kpiRealTime.currentDay)?.records || [];
        kpiRealTime.lastDaySales = groupedData.find(e => e.day !== kpiRealTime.currentDay)?.records || [];
    }

    // Manipula informações de pedidos em aberto
     if (Array.isArray(openOrders)) {
        kpiRealTime.listOfOpenOrders = openOrders;

        // Filtra e agrupa pedidos de mesas/comandas
        const tableOrders = openOrders.filter(e => e.tipoPedido === 'MESA' || e.tipoPedido === 'COMANDA');
        kpiRealTime.listOrdersTable = groupByOrderTable(tableOrders);
    }

    // Manipula informações de métricas de tempo (Tempos Médios)
    if (kpiTimeMetrics?.length > 0) {
        kpiRealTime.timeMetrics = kpiTimeMetrics
    }

    // Retorna o novo estado
    return {
        ...currentState,
        kpiRealTime
    };
};